import { render } from "./Report5View.vue?vue&type=template&id=ed65e69a"
import script from "./Report5View.vue?vue&type=script&lang=js"
export * from "./Report5View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__